import BaseContract from "../BaseContract";

export default class BaseErc20Contract extends BaseContract {}
